// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--1AXXX","links":"Footer-module--links--2k1Cu","socials":"Footer-module--socials--1tDgC","social":"Footer-module--social--3W-Pq"};